import script from "./DropdownNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownNotification.vue?vue&type=script&setup=true&lang=js"

import "./DropdownNotification.vue?vue&type=style&index=0&id=09000372&lang=css"

const __exports__ = script;

export default __exports__